//Import resources
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const MyWords = () => {
  //Pull in some variables or functions from the global CONTEXT
  const [userTranslations, setUserTranslations] = useState([]);

  //Use useState to set up the confirmDelete message
  const [confirmDelete, setConfirmDelete] = useState("");

  //Showing the 'confirm delete all' Alert or not
  const [showConfirm, setShowConfirm] = useState(false);

  //GET userTranslations from localStorage to display them
  const getUserTranslations = () => {
    // Local Storage version
    const userWords = JSON.parse(localStorage.getItem("userTranslations"));
    if (userWords) {
      setUserTranslations(userWords);
      console.log("Got userTranslations from localStorage");
    }
  };

  //run getUserTranslations() ONCE on page load using useEffect()
  useEffect(() => {
    getUserTranslations();
  }, []);

  //DELETE a translation from the database BUT if there are DUPLICATES in the database, the duplicates will still show in the UI???
  const deleteTranslation = (translation) => {
    //Set userTranslations in localStorage to be the exisiting list of userTranslations WITHOUT this specific translation
    let newList = userTranslations.filter((item) => item !== translation);
    localStorage.setItem("userTranslations", JSON.stringify(newList));
    setConfirmDelete(
      `Your translation for "${translation.split(" =")[0]}" has been deleted.`
    );
    getUserTranslations();
  };

  //DELETE all translations from the database
  const deleteAllTranslations = () => {
    // Local Storage version
    //Set userTranslations in localStorage to be an empty array
    localStorage.setItem("userTranslations", JSON.stringify([]));
    getUserTranslations();
    setConfirmDelete("All your translations have been deleted.");
    setShowConfirm(false);
  };

  ///////////////////
  //RETURN this JSX to UI
  return (
    <div className="container">
      <div>
        <h4 className="d-flex justify-content-center">Your words</h4>
      </div>

      <p className="d-flex justify-content-center text-danger">
        {confirmDelete}
      </p>

      {userTranslations.length < 1 ? (
        <h5 className="d-flex justify-content-center">
          You have no saved translations.
        </h5>
      ) : (
        <></>
      )}
      <div className="container d-flex justify-content-center">
        <ul className="list-unstyled">
          {userTranslations.map((translation) => {
            return (
              <li key={userTranslations.indexOf(translation)}>
                <div className="card m-3 p-2 border-success text-success text-center">
                  <h4 className="m-2">{translation}</h4>
                  <button
                    onClick={() => {
                      deleteTranslation(translation);
                    }}
                    className="btn btn-outline-danger m-2 btn-sm"
                  >
                    Delete
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <br />
      {userTranslations.length > 1 ? (
        <div className="d-flex justify-content-center mb-5">
          <button
            onClick={() => {
              setShowConfirm(true);
            }}
            className="btn btn-danger"
          >
            Delete All Translations
          </button>
        </div>
      ) : (
        <></>
      )}

      <Modal show={showConfirm} variant="danger" text-center>
        <Modal.Header>
          <h3 className="text-center">
            Are you sure you want to delete all the translations from your 'My
            Words' list?
          </h3>
        </Modal.Header>
        <Modal.Footer className="justify-content-center">
          <Button
            onClick={() => deleteAllTranslations()}
            variant="outline-danger"
          >
            Delete All Translations
          </Button>
          <Button onClick={() => setShowConfirm(false)} variant="outline-dark">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyWords;
